import React from "react"
import { StyleSheet, View } from "react-native"
import TextM from "../components/text/TextM"
import { theme } from "../theme/theme"

export const ModalCardSkeleton = ({ title, children, cond = true }) => {
    return cond ? (
        <View style={styles.card}>
            <TextM fontWeight="Bold" style={{ marginBottom: 8 }}>
                {title}
            </TextM>
            {children}
        </View>
    ) : null
}

const styles = StyleSheet.create({
    card: {
        backgroundColor: theme.colors.white,
        borderRadius: 12,
        borderWidth: 1,
        borderColor: theme.colors.lightMore,
        padding: 16,
        marginBottom: 12,
    },
})
